module.exports = __webpack_public_path__ + "5a716af299328425f38733b799cdc188.png";